import { render, staticRenderFns } from "./member.vue?vue&type=template&id=1d89c63d"
import script from "./member.vue?vue&type=script&lang=js"
export * from "./member.vue?vue&type=script&lang=js"
import style0 from "./member.vue?vue&type=style&index=0&id=1d89c63d&lang=scss"
import style1 from "./member.vue?vue&type=style&index=1&id=1d89c63d&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d89c63d')) {
      api.createRecord('1d89c63d', component.options)
    } else {
      api.reload('1d89c63d', component.options)
    }
    module.hot.accept("./member.vue?vue&type=template&id=1d89c63d", function () {
      api.rerender('1d89c63d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/games/tabs/member.vue"
export default component.exports